/*
 * Venda: keep the cart drawer and cart counts in sync with app cart changes.
 *
 * The Upcharge Fees app adds, updates and removes the "Handling fee" line with
 * its own /cart/*.js?app=mwsfees requests and never tells the theme, so the
 * drawer and [data-cart-count] go stale (e.g. "1" on an empty cart). After one
 * of those requests finishes, re-read the cart (GET only, so the app isn't
 * triggered again) and refresh through the theme's own Cart statics.
 */
const APP_REQUEST = /\/cart\/(add|change|update|clear)(\.js)?\?[^#]*app=mwsfees/;
// the fee app usually writes 2-3 times in a row about 0.9s apart; wait for it to
// settle so the drawer refreshes once rather than once per write
const SYNC_DELAY = 1000;

let sync_timer = null;

function scheduleSync() {
  clearTimeout(sync_timer);
  sync_timer = setTimeout(syncCart, SYNC_DELAY);
}

async function syncCart() {
  // don't replace the add-ons block while a customer's change is still pending
  if (document.querySelector('cart-addons[data-pending]')) {
    scheduleSync();
    return;
  }

  const Cart = customElements.get('cart-element');
  if (!Cart) return;

  try {
    const [cart_response, sections_response] = await Promise.all([
      fetch(`${Shopify.routes.cart}.js`),
      fetch(`${Shopify.routes.root}?sections=${Cart.sections.join(',')}`)
    ]);
    if (!cart_response.ok || !sections_response.ok) return;

    const { items, item_count } = await cart_response.json();
    const sections = await sections_response.json();

    Cart.fillBasket(items);
    Cart.updateTotals(item_count);
    Cart.updateAllHtml(sections);
  } catch {}
}

if ('PerformanceObserver' in window) {
  new PerformanceObserver(list => {
    if (list.getEntries().some(({ name }) => APP_REQUEST.test(name))) scheduleSync();
  }).observe({ type: 'resource', buffered: false });
}
